import { Wrapper, Main, BoxIcon } from './styles'
import { IoChatbubbleEllipsesOutline, IoClose } from 'react-icons/io5'

export default function App({ onChange, isOpen }) {
  return (
    <Wrapper onClick={onChange}>
      <Main open={isOpen}>
        <BoxIcon className={isOpen ? '' : 'iconHide'} style={{ position: 'absolute' }}>
          <IoClose size={44} color="white" />
        </BoxIcon>
        <BoxIcon className={isOpen ? 'iconHide' : ''} style={{ position: 'relative' }}>
          <IoChatbubbleEllipsesOutline size={44} color="white" />
        </BoxIcon>
      </Main>
    </Wrapper>
  )
}
